import { useQuery } from "@apollo/client";
import { FIND_COMPANY } from "graphql/queries";

export const useCompanyName = (companyId?: string) => {
  const { data } = useQuery(FIND_COMPANY, {
    variables: { id: companyId ?? "" },
    skip: !companyId,
  });
  return data?.company?.name;
};
